module.exports = __webpack_public_path__ + "img/sampleBySector.ddeec75d.png";